<template>
  <div class="security">
    <h2>Güvenlik</h2>

    <div class="form-group">
      <label for="email">Yeni E-posta</label>
      <input type="email" v-model="email" id="email" placeholder="Yeni e-posta adresiniz" />
    </div>

    <div class="form-group">
      <label for="currentPassword">Mevcut Şifre</label>
      <input type="password" v-model="currentPassword" id="currentPassword" placeholder="Mevcut şifreniz" />
    </div>

    <div class="form-group">
      <label for="newPassword">Yeni Şifre</label>
      <input type="password" v-model="newPassword" id="newPassword" placeholder="Yeni şifre" />
    </div>

    <div class="form-group">
      <label for="confirmPassword">Yeni Şifre (Tekrar)</label>
      <input type="password" v-model="confirmPassword" id="confirmPassword" placeholder="Yeni şifre tekrar" />
    </div>

    <button class="btn primary" @click="updateSecurity">Kaydet</button>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { getToken } from '@/utils/auth'
const baseURL = process.env.VUE_APP_API_URL
const email = ref('')
const currentPassword = ref('')
const newPassword = ref('')
const confirmPassword = ref('')

async function updateSecurity() {
  if (!currentPassword.value) {
    alert('Mevcut şifrenizi girmeniz gereklidir.')
    return
  }

  if (newPassword.value && newPassword.value !== confirmPassword.value) {
    alert('Yeni şifreler eşleşmiyor.')
    return
  }

  const payload = {
    currentPassword: currentPassword.value,
    email: email.value || null,
    newPassword: newPassword.value || null
  }

  const res = await fetch(`${baseURL}/settings/security`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify(payload)
  })

  const data = await res.json()
  if (res.ok) {
    alert(data.message || 'Güncellendi!')
    currentPassword.value = ''
    newPassword.value = ''
    confirmPassword.value = ''
    email.value = ''
  } else {
    alert(data.message || 'Bir hata oluştu.')
  }
}
</script>

<style scoped>
.security {
  max-width: 600px;
  margin: auto;
}
.form-group {
  margin-bottom: 15px;
}
label {
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
}
input {
  padding: 10px;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 6px;
}
.btn.primary {
  padding: 10px 20px;
  background-color: #0c2d57;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}
</style>
